import { useIDBKeyval } from "@vueuse/integrations/useIDBKeyval";
import type { Element, FigureAnnotation } from "types";
import type { Ref } from "vue";
const { data } = useIDBKeyval<Element[]>("elements", [], {
  shallow: false,
});

export function useFunctionalElementsState(): Ref<Element[]> {
  return data;
}

export function useFunctionalElementFigureAnnotationsState(
  element: Element
): Ref<FigureAnnotation[]> {
  const { data } = useIDBKeyval<FigureAnnotation[]>(
    `element-${element.id}-annotations`,
    []
  );
  return data;
}
